var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-wrapper"},[_c('b-img',{class:_vm.imageClass,attrs:{"thumbnail":"","fluid":"","src":(".." + _vm.imageUrl)},on:{"click":function($event){return _vm.$emit('imageClicked')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }